<template>
  <div class="custom_upload">
    <a-upload
      :multiple="multiple"
      :withCredentials="true"
      :showUploadList="false"
      :directory="false"
      :accept="accept"
      :before-upload="beforeUpload"
      :customRequest="customRequest"
    >
      <div class="btn" @click="getUploadFileOperationKey">
        <slot></slot>
      </div>
    </a-upload>
  </div>
</template>

<script>
import handleUpload from './methods/UploadAudioAndIrc';
import { testCanUploadType } from './methods/uploadConfig';

export default {
  components: {},
  props: {
    accept: {
      type: String,
      default: testCanUploadType.join(','),
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    columnKey: {
      type: String,
      default: 'defaultColumnKey',
    },
    articleKeys: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, context) {
    return {
      ...handleUpload(props, context, 'batchUploadJson', { articleKeys: props.articleKeys }),
    };
  },
};
</script>
